import { z } from 'zod';
/**
 * E-mail grátis (G5, plano mestre de 28/10): cada pessoa tem um endereço de encaminhamento
 * (`in+<código>@secretarios.net`). O que chega vira um resumo na conversa, com o compromisso
 * sugerido e um rascunho de resposta. Envio pelo Gmail e agenda do Google vêm depois da
 * verificação do Google; ler a caixa inteira (CASA) fica para quando houver tração.
 */
export const MAIL_DOMAIN = 'secretarios.net';
export const MAIL_LOCAL = 'in';
/** Quantos e-mails por dia viram resumo (o resto é ignorado em silêncio). */
export const MAIL_DAILY_LIMIT = 40;
export const mailAddressSchema = z.object({ address: z.string() });
export const mailAddressOf = (code) => `${MAIL_LOCAL}+${code}@${MAIL_DOMAIN}`;
/** O que o Worker da Cloudflare entrega à API: só o necessário, já lido do MIME. */
export const mailInboundSchema = z.object({
    to: z.string().trim().max(200),
    from: z.object({
        name: z.string().trim().max(120).nullable(),
        address: z.string().trim().max(200),
    }),
    subject: z.string().max(300).default(''),
    text: z.string().max(20_000).default(''),
    messageId: z.string().max(300).nullable().default(null),
    date: z.string().max(80).nullable().default(null),
});
